import React from 'react'
import {FaAngleDoubleUp} from 'react-icons/fa';
import { useState,useEffect } from 'react'

const ScrollToTop = () => {
    const [showTopBtn, setShowTopBtn] = useState(false)

    useEffect(()=>{
        window.addEventListener('scroll',function(){
            if(window.scrollY > 500){
                setShowTopBtn(true)
            }else{
                setShowTopBtn(false)
            }
        })
    },[])
    const goToTop = ()=> {
        window.scrollTo({
            top:0,
            behavior:"smooth",
        })
    }
  return (
    <div className='fixed right-[1rem] bottom-[2rem]'>

        {showTopBtn && (
              <FaAngleDoubleUp onClick={goToTop} className='animate text-[#fff] text-[2rem] cursor-pointer'/>
           )
        }
    </div>
  )
}

export default ScrollToTop
